<template>
<div>
<v-card style="width:100%;height:90px" class="secondary">
     <v-layout row wrap style="height:40px;">
      <v-flex xs10 style="padding:10px;" >
            <div class="title" style="color:white">Search Recharges</div>
      </v-flex>
      <v-flex xs2>
      <v-btn icon @click="fetchstatement" style="float:right"><v-icon style="margin-top:0px" color="white">refresh</v-icon></v-btn>
      </v-flex>
    </v-layout>
     <v-layout row wrap style="height:40px;">
      <v-flex xs12 style="padding-top:8px" >
         <v-btn class="success searchbtn" @click="fetchstatement"> Search</v-btn>
    <input type="number" class="search" v-model="mobile" placeholder="Enter Number">
    <v-menu
        :close-on-content-click="false"
        v-model="menu2"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date2" readonly class="search" placeholder="To Date" >
        <v-date-picker v-model="date2" @input="menu2 = false"></v-date-picker>
      </v-menu>
    <v-menu
        :close-on-content-click="false"
        v-model="menu1"
        lazy
        transition="scale-transition"
        offset-y
        style="float:right"
        >
         <input type="text" slot="activator"  v-model="date1" readonly class="search" placeholder="From Date" >
        <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
      </v-menu>
      </v-flex>
<v-layout row wrap>
    <v-spacer></v-spacer>
  </v-layout>

    </v-layout>
</v-card>
  <v-data-table
      :headers="headers"
      :items="statementlist"
      :search="search"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.orderid }}</td>
        <td >{{ props.item.service }}</td>
        <td >{{ props.item.mobile }}</td>
        <td >{{ props.item.type }}</td>
        <td >{{ props.item.amount }}</td>
        <td ><v-btn small :class="checkstatus(props.item.status)">{{ props.item.status }}</v-btn></td>
        <td >{{ props.item.tid }}</td>
        <td >{{ new Date(parseInt(props.item.time)) | moment("DD-MM-YYYY, h:mm:ss a")}}</td>
        <td><v-btn @click="getsummary(props.item.orderid)" small color="primary">View</v-btn></td>
      </template>
    </v-data-table>
      <v-dialog v-model="dialog" persistent width="300"><v-card color="primary" dark><v-card-text>Please wait <v-progress-linear indeterminate  color="white" class="mb-0"/></v-card-text></v-card></v-dialog>

     <v-dialog v-model="viewstatus" width="400">
     <v-card >
        <v-card-title style="height:40px">
          <span class="body-2">Summary of your Order</span>
        </v-card-title>
                <v-card-text style="padding-top:0px">
               <v-layout row wrap v-for="(item,key) in summary">
                     <v-flex  xs6>
                        <v-card-text class="px-0">{{key}}</v-card-text>
                     </v-flex>
                     <v-flex  xs6>
                        <v-card-text class="px-0">{{item}}</v-card-text>
                     </v-flex>
               </v-layout>
        </v-card-text>
         </v-card>
      </v-dialog>
</div>
</template>

<script>
export default {
   data(){
      return{
         modal:false,
         date1:'',
         menu1:false,
         date2:'',
         menu2:false,
         mobile:'',
         headers: [
               { text: 'Order No', value: 'orderno',align: 'left' },
               { text: 'Service', value: 'service' },
               { text: 'MobileNo', value: 'mobile' },
               { text: 'Type', value: 'type' },
               { text: 'Amount', value: 'amount' },
               { text: 'Status', value: 'status' },
               { text: 'TransactionID', value: 'transactionid' },
               { text: 'Recharge Time', value: 'time' },
               { text: 'Action', value: 'action' },
         ],
         dialog:false,
         viewstatus:false,
         statementlist:[],
         modal:false,
         search:'',
         summary:{}
      }
   },
   computed:{
      user(){
         return this.$store.getters.user;
      }
   },
   methods:{
      checkstatus(status){
         status = status.toLowerCase();
         if(status=="success")return "success"
         if(status=="pending")return "grey"
         if(status=="inprocess")return "warning"
         if(status=="failed")return "error"
         return "primary"
     },
      notification(type,message){
        this.$notify({
                group: 'foo',
                title: 'Important message',
                text: message,
                duration:5000,
                type:type
        })
      },
      pushstatement(value){
            let vm = this;
            vm.statementlist = []
            for(let i =0;i<value.length;i++){
               let doc = value[i]
               let time = doc.RechargeDate.replace("/Date(","").replace(")/","")
               vm.statementlist.push({
                  amount:doc.Amount,
                  orderid:doc.Id,
                  mobile:doc.MobileNo,
                  time:time,
                  service :doc.ServiceName,
                  type :doc.ServiceType,
                  status:doc.Status,
                  tid:doc.TransactionId
               })

            }

      },
      getsummary(id){
         let vm = this;
         let doc = {
           'MobileNo':vm.user.phone,
           'Password':vm.user.password,
           'AuthKey':vm.user.authkey,
           'Source':'json',
           'Autono':id
           }
            vm.dialog = true;
            vm.$store.dispatch("axiospost",{
                  url:"getRechargesById",
                  data:doc,
            }).then(function (res) {
                  vm.dialog = false;
                  vm.viewstatus =true;
                  let doc =res.data[0];
                  vm.summary ={
                     "Recharge Status": doc.Status,
                     "Recharge Amount": doc.Amount,
                     "Surcharge": doc.Surcharge,
                     "Commission": doc.Commission,
                     "Opening Balance": doc.OpeningBal,
                     "Closing Balance": doc.ClosingBal,
                     "Client Transaction Id": doc.ClientTxId,
                     "Transaction Id":doc.TransactionId,
                  }
            }).catch(function (error) {
                  vm.notification("error",error.message);
                  vm.dialog = false;
            })

      },
      fetchstatement(){
         let vm = this;
         if(!vm.user.phone) return vm.notification("warn","Authentication Required!");
         let doc = {
           'MobileNo':vm.user.phone,
           'Password':vm.user.password,
           'AuthKey':vm.user.authkey,
           'Source':'json',
           'recordcnt':'50',
           'getFromdate':vm.date1,
           'getTodate':vm.date2,
           'searchMobileNo':vm.mobile
           }
            vm.dialog = true;
            vm.$store.dispatch("axiospost",{
                  url:"getRechargesBySearch",
                  data:doc,
            }).then(function (res) {
                  vm.dialog = false;
                  vm.pushstatement(res.data)
            }).catch(function (error) {
                  vm.notification("error",error.message);
                  vm.dialog = false;
            })
   }
   },
   mounted(){
      let vm = this;
   }

}
</script>


<style scoped>
.search{
   width:150px;
   float: right;
   height: 34px;
   background: white;
   outline:none;
   margin-left:20px;
   padding-left:10px;
   font-size:1em;
}
.searchbtn{
   margin-right:15px;
   height: 34px;
   margin-left:20px;
   float: right;
   margin-top:0px;
}

</style>

